module.exports = __webpack_public_path__ + "static/media/lotus.83bcc0be.svg";